import { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cached so multiple chips on the same page don't re-fetch.
let _onchainPromise = null;
function fetchOnchain() {
  if (!_onchainPromise) {
    _onchainPromise = fetch(`${API_URL}/api/onchain`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return _onchainPromise;
}

/**
 * Small "DEVNET LIVE · view program/mint/season" link chip that other Codex
 * pages can drop into their hero/footer. Only renders when the on-chain
 * config is actually deployed.
 */
export default function OnChainChip({
  target = 'program', // 'program' | 'mint' | 'season'
  label,              // optional override
  className = '',
  testId = 'onchain-chip',
}) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let live = true;
    fetchOnchain().then((d) => { if (live) setCfg(d); });
    return () => { live = false; };
  }, []);

  if (!cfg || !cfg.deployed || !cfg.explorer || !cfg.explorer[target]) return null;
  const labelMap = {
    program: 'view program',
    mint:    'view token mint',
    season:  'view season account',
  };

  return (
    <a
      href={cfg.explorer[target]}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[9.5px] font-bold tracking-[0.22em] hover:brightness-125 transition-all ${className}`}
      style={{
        fontFamily: "'JetBrains Mono','Fira Code',monospace",
        color: '#7dd0ff',
        background: 'rgba(8,18,28,0.85)',
        border: '1px solid rgba(125,208,255,0.45)',
        boxShadow: '0 0 10px rgba(125,208,255,0.12)',
        borderRadius: 2,
      }}
    >
      <span
        className="inline-block rounded-full"
        style={{ width: 5, height: 5, background: '#7dd0ff', boxShadow: '0 0 6px #7dd0ff' }}
      />
      DEVNET LIVE · {label || labelMap[target] || 'view'}
      <ExternalLink className="w-2.5 h-2.5 opacity-80" />
    </a>
  );
}
